import React, { Component } from 'react';
import { bool, func, string } from 'prop-types';

import CSS from './styles.scss';
import MenuViews from './views';


class Menu extends Component {
  toggle = e => {
    const { textContent:selection } = e.target;
    const { parentToggle } = this.props;

    if (e.keyCode && e.keyCode === 13) {
      parentToggle(selection);
    }

    if (!e.keyCode) {
      parentToggle(selection);
    }
  }

  render() {
    const { isDisabled, isLoading, activeMenu } = this.props;

    let ebookListItem = `${CSS['list__item--active']}`;
    let ebookTabItem = `${CSS['tab__item--active']}`;
    let notebookListItem = `${CSS['list__item']}`;
    let notebookTabItem = `${CSS['tab__item']}`;
    let pageNumberListItem = `${CSS['list__item']}`;
    let pageNumberTabItem = `${CSS['page__tab__item']}`;

    if (isDisabled || isLoading) {
      ebookListItem = `${CSS['list__item--disabled']}`;
      notebookListItem = `${CSS['list__item--disabled']}`;
      pageNumberListItem = `${CSS['list__item--disabled']}`;
      ebookTabItem = `${CSS['tab__item--disabled']}`;
      notebookTabItem = `${CSS['tab__item--disabled']}`;
      pageNumberTabItem = `${CSS['tab__item--disabled']}`;
    } else {
      if (activeMenu !== 'E-book') {
        ebookListItem = `${CSS['list__item']}`;
        ebookTabItem = `${CSS['tab__item']}`;
        pageNumberListItem = `${CSS['list__item']}`;
        pageNumberTabItem = `${CSS['page__tab__item']}`;
        notebookListItem = `${CSS['list__item--active']}`;
        notebookTabItem = `${CSS['tab__item--active']}`;
      }
    }

    const viewProps = {
      ebookListItem,
      ebookTabItem,
      notebookListItem,
      notebookTabItem,
      pageNumberTabItem,
      pageNumberListItem,
      activeMenu: this.props.activeMenu,
      showPageSelector: this.props.showPageSelector,
      toggle: this.toggle
    };

    return <MenuViews { ...viewProps } />;
  }
}

Menu.propTypes = {
  activeMenu: string,
  isDisabled: bool,
  isLoading: bool,
  parentToggle: func,
  showPageSelector: bool
};


export default Menu;
